// Configurações de ambiente
// Local: use REACT_APP_API_BASE_URL=/api + package.json "proxy" → Laravel em localhost:8000
// Sem proxy (ex.: build estático): use http://localhost:8000/api e habilite CORS no backend
export const config = {
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || '/api',
  ENV: process.env.REACT_APP_ENV || 'development',
};
